import { isEmptyString, isNullOrUndefined } from "../../../utils/utils";
import { IdentityType, PrimaryIdentityInfo } from "../../interfaces/IAuthenticationProvider";

export async function GetPrimaryIdentity() {
  return await GetPrimaryIdentityInfo();
}

export function IsPrimaryIdentityInformationValid(primaryIdentity: PrimaryIdentityInfo | null) {
  if (!isNullOrUndefined(primaryIdentity) && (primaryIdentity?.displayName != undefined && !isEmptyString(primaryIdentity?.displayName))
    && (primaryIdentity?.email != undefined && !isEmptyString(primaryIdentity?.email))) {
    return true;
  }
  return false;
}

export async function GetPrimaryIdentityInfo(): Promise<PrimaryIdentityInfo> {
  //Note: getPrimaryIdentityInfo is called to get the primary identity type of the accounts logged in.
  const primaryIdentityValue = await OfficeFirstPartyAuth.getPrimaryIdentityInfo();
  const identityType = primaryIdentityValue.identityType;

  switch (identityType) {
      case IdentityType.ODP:
          return { type: IdentityType.ODP, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
      case IdentityType.ODB:
          return { type: IdentityType.ODB, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
      default:
          return { type: IdentityType.Unsupported, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
  }
}